// extracted by mini-css-extract-plugin
module.exports = {"text":"faqgroup_text___8JKg","noLinkUnderlines":"faqgroup_noLinkUnderlines__ySjaM"};